<template>
    <div class="item-question mt-1 mb-lg-5">
        <span v-if="text" v-html="$t(text)" />
        <slot />
    </div>
</template>
<script>
export default {
    name: 'question',
    props: {
        text: {
            type: String
        }
    }
}
</script>
<style lang="scss">
.item-question {
    margin-bottom: 2em;
    font-size: 1rem; 
    @media screen and (min-width: 992px) {
        font-size: 1.1rem;
    }
}
</style>